/**
 * @module
 *
 * @import {Amateur} from "../model/amateur";
 */

import {createContext, localValue} from "@acng/frontend-relativity";
import {Error} from '@acng/frontend-bounty/std/error.js';

/**
 * Observe an {@link Amateur} of the closest providing DOM parent.
 * Provide an {@link Amateur} to a DOM subtree.
 *
 * @type {import("@acng/frontend-relativity").LegacyContext<?Amateur> & import("@acng/frontend-relativity").ObservableType<?Amateur>}
 */
export const ctxAmateur = createContext();

/**
 * TODO {@link ctxAmateur} should not provide null.
 *
 * @param {Element} element
 *
 * @returns {Amateur}
 */
export const getLocalAmateur = (element) => {
  const amateur = localValue(element, ctxAmateur);

  if (!amateur) {
    throw Error('no amateur');
  }

  return amateur;
};
